'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _ramda = require('ramda');

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility.js');

var _functional_utility2 = _interopRequireDefault(_functional_utility);

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _functional_utility3 = require('../../../packages/common-utilities/src/functional_utility');

var _constants = require('common-utilities/src/constants');

var _accessibility_utility = require('../../../packages/common-utilities/src/accessibility_utility');

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var FundAwardsAndRatingsCard = function (_React$Component) {
  _inherits(FundAwardsAndRatingsCard, _React$Component);

  function FundAwardsAndRatingsCard(props) {
    _classCallCheck(this, FundAwardsAndRatingsCard);

    var _this = _possibleConstructorReturn(this, (FundAwardsAndRatingsCard.__proto__ || Object.getPrototypeOf(FundAwardsAndRatingsCard)).call(this, props));

    _this.handleDisclosureIconClick = _this.handleDisclosureIconClick.bind(_this);
    return _this;
  }

  _createClass(FundAwardsAndRatingsCard, [{
    key: 'renderFundAwardsAndRatings',
    value: function renderFundAwardsAndRatings(fundRatings, aemAwards) {
      var _this2 = this;

      var awardsContent = void 0;

      if ((0, _functional_utility3.doesVisibleDataPointContains)("SHOW_AWARDS_FROM_FDP", this.props, ["visibleDataPoints"])) {
        awardsContent = !(0, _ramda.isNil)(this.props.fundPerformanceRatings) ? mapIndexed(function (rating, index) {
          if (rating.isAward) {
            return _this2.renderFundAwardImage(_this2.props.gaiaRedirectUrl + '/images/' + rating.imageUrl, index);
          }
          return null;
        }, this.props.fundPerformanceRatings) : null;
      } else {
        awardsContent = !(0, _ramda.isNil)(aemAwards) ? mapIndexed(function (award, index) {
          return _this2.renderFundAwardImage(award.imageURL, index);
        }, aemAwards) : null;
      }

      var fundRatingDiv = !(0, _ramda.isNil)(fundRatings) ? (0, _ramda.map)(function (fundRating) {
        if (!fundRating.isAward) {
          return _this2.renderFundRating(fundRating);
        }
      }, fundRatings) : null;

      if (!((0, _functional_utility3.isNilOrEmpty)(awardsContent) && (0, _functional_utility3.isNilOrEmpty)(fundRatingDiv))) {
        return _react2.default.createElement(
          'div',
          { className: 'container width-percent-100 padding-all-0 margin-top-30' },
          _react2.default.createElement(
            'div',
            { className: 'row row-equal padding-all-0 margin-horizontal-0' },
            fundRatingDiv,
            awardsContent
          )
        );
      }
    }
  }, {
    key: 'renderFundRating',
    value: function renderFundRating(fundRating) {

      return _react2.default.createElement(
        'div',
        { key: fundRating.disclosureId, className: 'col-xs-6 col-sm-6 col-md-4 col-lg-6 col-xlg-6 col-equal padding-vertical-0 padding-horizontal-6 margin-top-10', style: this.props.breakpoint >= 3 ? { "min-height": "85px" } : { "min-height": "80px" } },
        _react2.default.createElement(
          'div',
          { className: 'padding-all-0 vertical-align-middle', style: { "min-height": "55" } },
          _react2.default.createElement('img', {
            src: this.props.gaiaRedirectUrl + '/images/' + fundRating.imageUrl,
            'data-testid': 'fund-rating-image',
            className: "vertical-align-top",
            style: { "max-height": "55px", "max-width": "120px" } })
        ),
        _react2.default.createElement(
          'div',
          null,
          this.renderAsOfDate(fundRating),
          this.renderIcon(fundRating.disclosureId)
        )
      );
    }
  }, {
    key: 'renderAsOfDate',
    value: function renderAsOfDate(fundRating) {
      if ((0, _ramda.isNil)(fundRating.effectiveDate)) {
        return null;
      }

      return _react2.default.createElement(
        'span',
        { className: 'font-light disclaimer margin-top-10',
          'data-testid': 'summary-header-perf-rating-as-of-date' },
        _string_utility2.default.renderFormattedLabel("As of ", "label-for-as-of"),
        _date_formatter2.default.formatDateForLocale(fundRating.effectiveDate)
      );
    }
  }, {
    key: 'renderFundAwardImage',
    value: function renderFundAwardImage(imageUrl, index) {
      var imageStyle = { 'max-width': '120px', 'max-height': '85px' };
      if (!(0, _ramda.isNil)(imageUrl)) {
        return _react2.default.createElement(
          'div',
          { key: index, className: 'col-xs-6 col-sm-6 col-md-4 col-lg-6 col-xlg-6 margin-top-10 margin-bottom-20 padding-horizontal-6' },
          _react2.default.createElement('img', { src: imageUrl, 'data-testid': 'fund-award-image-' + index, style: imageStyle, alt: '' })
        );
      }
    }
  }, {
    key: 'getIconEl',
    value: function getIconEl(tooltipId) {
      return document.querySelectorAll('#disclosure-' + tooltipId)[1];
    }
  }, {
    key: 'renderIcon',
    value: function renderIcon(tooltipId) {
      var _this3 = this;

      var _props = this.props,
          breakpoint = _props.breakpoint,
          disclosure = _props.disclosure,
          tooltip = _props.tooltip;

      if (!disclosure || (0, _ramda.isNil)(disclosure[tooltipId])) {
        return null;
      }

      return _react2.default.createElement(
        'span',
        { id: 'disclosure-' + tooltipId, tabIndex: 0, 'data-testid': 'disclosure-' + tooltipId, ref: function ref(el) {
            return _this3[tooltipId] = el;
          }, className: 'icon-info print-hide margin-left-5',
          role: 'tooltip',
          onKeyDown: function onKeyDown(event) {
            return _accessibility_utility2.default.handleEnterClick(_this3, event, _this3.handleDisclosureIconClick.bind(_this3, event, tooltipId, disclosure, tooltip, breakpoint));
          },
          onClick: function onClick(event) {
            return _this3.handleDisclosureIconClick(event, tooltipId, disclosure, tooltip, breakpoint);
          }
        },
        ' '
      );
    }
  }, {
    key: 'handleDisclosureIconClick',
    value: function handleDisclosureIconClick(event, tooltipId, disclosure, tooltip, breakpoint) {
      var el = this[tooltipId];
      var elHeight = el.offsetHeight;
      var elWidth = el.parentNode.getBoundingClientRect().left;
      var elRect = el.getBoundingClientRect();
      var arrowHeight = 4;
      var docTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;

      var toolTipWidth = void 0,
          toolTipContentWidth = void 0,
          closeTipPosition = void 0,
          toolTipContentScroll = void 0,
          toolTipRightPosition = 'hidden';
      if (breakpoint > 3) {
        if (disclosure[tooltipId][0].length > 200) {
          elWidth -= 150;
          toolTipWidth = 570;
          toolTipContentWidth = 530;
          closeTipPosition = 530;
        } else {
          toolTipWidth = 300;
          toolTipContentWidth = 300;
          closeTipPosition = 260;
        }
        toolTipRightPosition = elWidth + toolTipWidth;
        if (toolTipRightPosition > window.innerWidth) {
          elWidth = window.innerWidth - toolTipWidth;
        }
      } else if (disclosure[tooltipId][0].length > 200) {
        toolTipContentScroll = 'auto';
      }
      var elOffset = {
        top: elRect.top + docTop + arrowHeight + elHeight,
        left: elWidth,
        arrowPosition: elRect.left - elWidth - 3,
        toolTipWidth: toolTipWidth,
        toolTipContentWidth: toolTipContentWidth,
        closeTipPosition: closeTipPosition,
        toolTipContentScroll: toolTipContentScroll
      };

      tooltip.openTooltip(elOffset, disclosure[tooltipId], null, true, event);
    }
  }, {
    key: 'getDisclosureText',
    value: function getDisclosureText(aemAwards) {
      if ((0, _functional_utility3.doesVisibleDataPointContains)("SHOW_AWARDS_FROM_FDP", this.props, ["visibleDataPoints"])) {
        return (0, _ramda.pathOr)([], ["disclosure", "pdpCardAwards"], this.props);
      } else {
        return !(0, _ramda.isNil)(aemAwards) ? aemAwards.map(function (award) {
          return award.disclosure;
        }).filter(function (disclosureText) {
          return !(0, _functional_utility3.isNilOrEmpty)(disclosureText);
        }) : [];
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var aemAwards = null;
      if (!(0, _ramda.isNil)(this.props.fundAwards) && !(0, _functional_utility3.isNilOrEmpty)(this.props.fundAwards[this.props.cusip])) {
        (function () {
          var unorderedFundAwards = _this4.props.fundAwards[_this4.props.cusip];
          aemAwards = [];
          var orderedFundAwards = (0, _constants.getOrderedFundAwardsConstant)();

          var _loop = function _loop(i) {
            aemAwards.push((0, _ramda.filter)((0, _ramda.propSatisfies)(function (x) {
              return x === orderedFundAwards[i].awardType;
            }, 'awardType'), unorderedFundAwards));
          };

          for (var i = 0; i < orderedFundAwards.length; i++) {
            _loop(i);
          }
          aemAwards = (0, _ramda.flatten)(aemAwards);
        })();
      }

      var awardsRatingsData = this.renderFundAwardsAndRatings(this.props.fundRatings, aemAwards);

      if ((0, _ramda.isNil)(awardsRatingsData)) {
        return null;
      }

      return _react2.default.createElement(
        _card_component2.default,
        {
          headerTitle: _string_utility2.default.renderFormattedLabel("Additional ratings and awards", "pdp-overview-additional-ratings-awards"),
          headerTitleId: "fundRatingsAndAwardsCardHeaderId",
          headerTitleLabel: "",
          breakpoint: this.props.breakpoint,
          headerLabel: "",
          disclosureText: this.getDisclosureText(aemAwards),
          placementId: "pdpCardAwards",
          style: _functional_utility2.default.ifMobileBreakpoint(this.props.breakpoint, { "padding-left": "16px", "padding-right": "16px" }, {}),
          disclosureWidthOverride: 75
        },
        awardsRatingsData
      );
    }
  }]);

  return FundAwardsAndRatingsCard;
}(_react2.default.Component);

exports.default = (0, _reactIntl.injectIntl)(FundAwardsAndRatingsCard, { withRef: true });